import React from "react";
import { Box, TextField } from "@mui/material";

// Normalize coordinates: accept object, JSON string, or double-encoded JSON string.
// Returns object { lat: string, lon: string } (strings keep empty state and uncontrolled->controlled issues avoided)
export function normalizeCoords(value) {
  if (value === undefined || value === null || value === "")
    return { lat: "", lon: "" };
  try {
    let coords = value;
    // If string, keep parsing until we get an object or fail
    while (typeof coords === "string") {
      coords = JSON.parse(coords);
    }
    if (!coords || typeof coords !== "object") return { lat: "", lon: "" };
    return { lat: coords.lat ?? "", lon: coords.lon ?? "" };
  } catch {
    return { lat: "", lon: "" };
  }
}

export default function CoordinateInput({
  value,
  onChange,
  error,
  helperText,
}) {
  const coords = normalizeCoords(value);

  const handle = (field) => (e) => {
    const next = { ...coords, [field]: e.target.value };
    // always pass an object back to parent
    onChange(next);
  };

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center", mt: 1 }}>
      <TextField
        label="Latitude"
        type="number"
        fullWidth
        margin="dense"
        value={coords.lat}
        onChange={handle("lat")}
        error={!!error}
      />
      <TextField
        label="Longitude"
        type="number"
        fullWidth
        margin="dense"
        value={coords.lon}
        onChange={handle("lon")}
        error={!!error}
        helperText={helperText}
      />
    </Box>
  );
}
